import { useEffect, useState } from "react";
import Breadcrumb from "../../breadcrump/Breadcrumb";
import Layout from "../../layout/Layout";
import ChooseFile from "../../Hospitals/ChooseFile";
import FasttagToggle from "../../FasttagRevenue/FasttagToggle";
import Closebtn from "../../assests/Closebtn";
import { useAddHostpital } from "../../../hooks/hospitals/useAddHostpital";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import InputField from "../../InputFields/InputField";
import TextArea from "../../InputFields/TextArea";
import FullscreenLoader from "../../loadings/FullscreenLoader";
import Checkbox from "../../InputFields/Checkbox";
import { toast } from "react-toastify";
import { useGetDistrict } from "../../../hooks/useGetDistrict";
import SelectField from "../../InputFields/SelectField";
import UploadFiles from "../../fileuploads/UploadFiles";

function AddHospital() {
  const [toggleFasttag, setToggleFasttag] = useState(false);

  const [profilePic, setProfilePic] = useState("");
  const { mutate, isLoading } = useAddHostpital();
  const methods = useForm();
  const control = methods.control;
  const isSameAsCompanyAddress = useWatch({ control, name: "sameascompany" });

  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [file3, setFile3] = useState(null);
  useEffect(() => {
    methods.reset({
      fastTagcount: toggleFasttag ? 5 : 0,
    });
  }, [toggleFasttag]);

  const breadCrumpData = [
    {
      name: "Hospitals",
      status: "inactive",
      link: "/manage-hospitals",
    },
    {
      name: "Add Hospitals",
      status: "active",
      link: "/manage-hospitals/add-hospital",
    },
  ];
  const { data: districts = [], isLoading: districtLoading } = useGetDistrict();
  const districtOptions = districts?.map((item) => ({
    label: item.name,
    value: item.id,
  }));
  const handleFileURL = (fileURL) => {
    setProfilePic(fileURL);
  };
  const onCreateHospital = async (data) => {
    if (data.accountNumber === data.verifyAccountnumber) {
      const file1Details = {
        name: file1?.name,
        file: file1?.key || file1?.file,
      };
      const file2Details = {
        name: file2?.name,
        file: file2?.key || file2?.file,
      };
      const file3Details = {
        name: file3?.name,
        file: file3?.key || file3?.file,
      };
      const fileArray = [file1Details, file2Details, file3Details].filter(
        (file) => file.name && file.file
      );
      const hospital = {
        name: data?.hospitalName,
        logo: profilePic,
        location: data?.town,
        address: {
          lineOne: data?.companyName,
          lineTwo: data?.address,
          city: data?.town,
          district: data?.district.value,
          state: data?.state,
          pincode: data?.pincode,
          street: data?.street,
        },
        billing_address: {
          lineOne: data?.billingAccountHoldername,
          lineTwo: data?.billingAddress,
          city: data?.billingTown,
          district: data?.billingDistrict?.value,
          state: data?.billingState,
          pincode: data?.billingPincode,
          street: data?.billingStreet,
        },
        admin: {
          name: data?.adminName,
          email: data?.adminEmail,
          password: data?.adminPassword,
        },
        fastTag: {
          enabled: toggleFasttag,
          count: toggleFasttag ? parseInt(data?.fastTagcount) : 0,
          price: toggleFasttag ? parseInt(data?.fasttagPrice) : 0,
        },
        bank_details: {
          account_number: data?.accountNumber,
          account_holder: data?.accountHoldername,
          ifsc: data?.ifsc,
          bank_name: data?.bankname,
          upi_id: data?.upiid,
        },
        contact_details: {
          email: data?.email,
          mobile: data?.phone,
          website: data?.website,
        },
        gst: data?.gstnumber,
        documents: fileArray,
        status: "active",
        district_id: data?.district.value,
        about: data?.about
      };
      await mutate(hospital);
      // methods.reset();
    } else {
      const errorMessage = "Account number mismatch";
      toast.error(errorMessage);
    }
  };
  return (
    <Layout
      activeClassName="manage-hospitals"
      id="menu-item3"
      id1="menu-items3"
    >
      {isLoading && <FullscreenLoader />}
      <div className="page-wrapper">
        <div className="content">
          <Breadcrumb data={breadCrumpData} />
          <div className="bg-white rounded p-4 mt-3">
            <div className="row">
              <div className="col">
                <h4>Hospital Onboarding</h4>
              </div>
              <div className="col d-flex justify-content-end">
                <Closebtn />
              </div>
            </div>

            <FormProvider {...methods}>
              <form onSubmit={methods.handleSubmit(onCreateHospital)}>
                <div className="row mt-4">
                  <div className="col-md-8 ms-md-3">
                    <ChooseFile
                      handleFileURL={handleFileURL}
                      fileURL={profilePic}
                    />
                  </div>
                </div>
                <div className="w-100 mt-4 mt-md-2">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <InputField
                          name="hospitalName"
                          label="Hospital Name"
                          validation={{ required: "Hospital Name is required" }}
                          placeholder="Hospital name"
                          type="text"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <InputField
                          name="email"
                          label="Contact Email"
                          validation={{ required: "Contact email is required" }}
                          placeholder="Contact email"
                          type="email"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <InputField
                        name="phone"
                        label="Contact Number"
                        validation={{ required: "Contact number is required" }}
                        placeholder=""
                        type="phone"
                      />
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="form-group">
                      <InputField
                        name="website"
                        label="Hospital Website"
                        // validation={{ required: "Hospital Website is required" }}
                        placeholder="Hospital website"
                        type="text"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="form-group col-12">
                    <TextArea
                      name="about"
                      label="About"
                      // validation={{ required: "Description is required" }}
                      placeholder="Write here.."
                      // disabled={isSameAsCompanyAddress}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <InputField
                        name="adminName"
                        label="Admin Name"
                        validation={{ required: "Admin Name is required" }}
                        placeholder="Admin name"
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <InputField
                        name="adminEmail"
                        label="Admin Email ID"
                        validation={{ required: "Admin Email is required" }}
                        placeholder="Admin email"
                        type="email"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <InputField
                        name="adminPassword"
                        label="Password"
                        validation={{ required: "Password is required" }}
                        placeholder="Admin password"
                        type="password"
                      />
                    </div>
                  </div>
                </div>
                <h4 className="card-title">GSTIN</h4>
                <div className="w-50">
                  <InputField
                    name="gstnumber"
                    label="GST Number"
                    placeholder="GST Number"
                    type="text"
                  />
                </div>

                <h4 className="card-title mt-4">Fast Tag</h4>
                <div className="row">
                  <div className="col-md-3">
                    <div className="d-flex pt-5">
                      <label className="">Enable Fast Tag</label>
                      <div className="ms-2">
                        <FasttagToggle setToggleFasttag={setToggleFasttag} />
                      </div>
                    </div>
                  </div>
                  {toggleFasttag && (
                    <div className="col-md-4">
                      <InputField
                        name="fastTagcount"
                        label="Fasttag Count"
                        // validation={{ required: "Fasttag issues per day is required" }}
                        placeholder="Fasttag issues per day"
                        type="number"
                        disabled={!toggleFasttag}
                        defaultValue={5}
                        validation={{
                          validate: (value) =>
                            Number(value) >= 5 ||
                            "Value must be greater than or equal to 5",
                        }}
                        minValue={5}
                      />
                    </div>
                  )}
                  {toggleFasttag && (
                    <div className="col-md-4">
                      <InputField
                        name="fasttagPrice"
                        label="Fasttag Price"
                        validation={{ required: "Fasttag price is required" }}
                        placeholder="Fasttag Price"
                        type="price"
                        disabled={!toggleFasttag}
                      />
                    </div>
                  )}
                </div>

                <h4 className="card-title mt-1">Hospital Location</h4>
                <div className="row">
                  <div className="col-md-4">
                    <InputField
                      name="companyName"
                      label="Hospital Name"
                      validation={{ required: "Hospital name is required" }}
                      placeholder="Hospital name"
                      type="text"
                    />
                  </div>

                  <div className="col-md-8">
                    <InputField
                      name="street"
                      label="Location"
                      validation={{ required: "Street is required" }}
                      placeholder="Area / Street / Sector"
                      type="text"
                    />
                  </div>
                </div>

                <div className="form-group mt-2">
                  <TextArea
                    name="address"
                    label="Address"
                    validation={{ required: "Address is required" }}
                    placeholder="Enter Address"
                  />
                </div>

                <div className="row">
                  <div className="col-md-7">
                    <div className="form-group">
                      <InputField
                        name="town"
                        label="Town"
                        validation={{ required: "Town is required" }}
                        placeholder="Town"
                        type="text"
                      />
                    </div>
                  </div>

                  <div className="col-md-5">
                    <div className="form-group">
                      <SelectField
                        options={districtOptions || []}
                        label="District"
                        isLoading={districtLoading}
                        name="district"
                        isMultiSelect={false}
                        placeholder="Select District"
                        validationMessage="District is required"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-7">
                    <div className="form-group">
                      <InputField
                        name="state"
                        label="State"
                        validation={{ required: "State is required" }}
                        placeholder="State"
                        type="text"
                      />
                    </div>
                  </div>

                  <div className="col-md-5">
                    <div className="form-group">
                      <InputField
                        name="pincode"
                        label="Pincode"
                        validation={{ required: "Pincode is required" }}
                        placeholder="Pincode"
                        type="text"
                      />
                    </div>
                  </div>
                </div>

                <h4 className="card-title mt-3">Add Bank Account</h4>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <InputField
                        name="accountNumber"
                        label="Account number"
                        validation={{ required: "Account Number is required" }}
                        placeholder="Account Number"
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <InputField
                        name="verifyAccountnumber"
                        label="Verify accountnumber"
                        validation={{ required: "Account Number is required" }}
                        placeholder="Verify Account Number"
                        type="text"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <InputField
                        name="accountHoldername"
                        label="Account holder name"
                        validation={{
                          required: "Account Holder Name is required",
                        }}
                        placeholder="Account Holder Name"
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <InputField
                        name="bankname"
                        label="Bank name"
                        validation={{ required: "Bank name is required" }}
                        placeholder="Bank name"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <InputField
                        name="ifsc"
                        label="Ifsc"
                        validation={{ required: "IFSC Code is required" }}
                        placeholder="IFSC"
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="form-group">
                      <InputField
                        name="upiid"
                        label="UPI id"
                        // validation={{ required: "IFSC Code is required" }}
                        placeholder="Upi id (optional)"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-between">
                  <h4 className="card-title mt-3">Billing Address</h4>
                  <Checkbox
                    name="sameascompany"
                    label="Same as Hospital Address"
                    validation={null}
                    // onChangeHandler={handleChcekbox}
                  />
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <InputField
                        name="billingAccountHoldername"
                        label="Account Holder Name"
                        validation={{
                          required: "Account Holder Name is required",
                        }}
                        placeholder="Account Holder Name"
                        type="text"
                        disabled={isSameAsCompanyAddress}
                      />
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="form-group">
                      <InputField
                        name="billingStreet"
                        label="Location"
                        validation={{ required: "Street is required" }}
                        placeholder="Area / Street / Sector"
                        type="text"
                        disabled={isSameAsCompanyAddress}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <TextArea
                    name="billingAddress"
                    label="Billing Address"
                    validation={{ required: "Address is required" }}
                    placeholder="Enter Address"
                    disabled={isSameAsCompanyAddress}
                  />
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <InputField
                        name="billingTown"
                        label="Town"
                        validation={{ required: "Town is required" }}
                        placeholder="Town / City"
                        type="text"
                        disabled={isSameAsCompanyAddress}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <SelectField
                        options={districtOptions || []}
                        label="District"
                        isLoading={districtLoading}
                        name="billingDistrict"
                        isMultiSelect={false}
                        placeholder="Select District"
                        validationMessage="Billing District is required"
                        disabled={isSameAsCompanyAddress}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <InputField
                        name="billingState"
                        label="State"
                        validation={{ required: "State is required" }}
                        placeholder="State"
                        type="text"
                        disabled={isSameAsCompanyAddress}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <InputField
                        name="billingPincode"
                        label="Pincode"
                        validation={{ required: "Pincode is required" }}
                        placeholder="Pincode"
                        type="text"
                        disabled={isSameAsCompanyAddress}
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-4">
                  <div className="edit-hospital">
                    <h4>Related Documents</h4>
                    <p>upload related documents to complete the process</p>
                  </div>
                  <div className="row mt-4 pb-5">
                    <div className="col-md-4 mt-2">
                      <UploadFiles
                        fileDetails={file1}
                        setFileDetails={setFile1}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <UploadFiles
                        fileDetails={file2}
                        setFileDetails={setFile2}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <UploadFiles
                        fileDetails={file3}
                        setFileDetails={setFile3}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="settings-btns col-md-12 col-sm-12 mt-md-0 mt-2">
                    <div className="d-flex justify-content-md-end justify-content-end">
                      <button
                        type="submit"
                        className="border-0 btn-primary btn-main-primary text-white"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default AddHospital;
